/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Compareagainst1Inputs */

const id_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan dengan`)
};

const ms_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan dengan`)
};

const da_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign med`)
};

const de_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleichen mit`)
};

const en_us2_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare against`)
};

const es_es2_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar con`)
};

const es_mx2_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar con`)
};

const fil_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihambing sa`)
};

const fr_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer avec`)
};

const it_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta con`)
};

const hu_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összehasonlítás ezzel`)
};

const nl_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijken met`)
};

const no_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign med`)
};

const pl_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównaj z`)
};

const pt_br2_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar com`)
};

const pt_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar com`)
};

const ro_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compară cu`)
};

const fi_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertailukohde`)
};

const sv_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför med`)
};

const vi_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sánh với`)
};

const tr_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şununla karşılaştır`)
};

const cs_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porovnat s`)
};

const bg_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнение с`)
};

const ru_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнить с`)
};

const uk_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порівняти з`)
};

const ar_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقارنة مع`)
};

const hi_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तुलना करें`)
};

const th_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปรียบเทียบกับ`)
};

const ja_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較対象`)
};

const zh_cn2_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较对象`)
};

const zh_hant1_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較對象`)
};

const ko_builds_comparison_compareagainst1 = /** @type {(inputs: Builds_Comparison_Compareagainst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비교 대상`)
};

/**
* | output |
* | --- |
* | "Compare against" |
*
* @param {Builds_Comparison_Compareagainst1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_compareagainst1 = /** @type {((inputs?: Builds_Comparison_Compareagainst1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Compareagainst1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_compareagainst1(inputs)
	if (locale === "ms") return ms_builds_comparison_compareagainst1(inputs)
	if (locale === "da") return da_builds_comparison_compareagainst1(inputs)
	if (locale === "de") return de_builds_comparison_compareagainst1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_compareagainst1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_compareagainst1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_compareagainst1(inputs)
	if (locale === "fil") return fil_builds_comparison_compareagainst1(inputs)
	if (locale === "fr") return fr_builds_comparison_compareagainst1(inputs)
	if (locale === "it") return it_builds_comparison_compareagainst1(inputs)
	if (locale === "hu") return hu_builds_comparison_compareagainst1(inputs)
	if (locale === "nl") return nl_builds_comparison_compareagainst1(inputs)
	if (locale === "no") return no_builds_comparison_compareagainst1(inputs)
	if (locale === "pl") return pl_builds_comparison_compareagainst1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_compareagainst1(inputs)
	if (locale === "pt") return pt_builds_comparison_compareagainst1(inputs)
	if (locale === "ro") return ro_builds_comparison_compareagainst1(inputs)
	if (locale === "fi") return fi_builds_comparison_compareagainst1(inputs)
	if (locale === "sv") return sv_builds_comparison_compareagainst1(inputs)
	if (locale === "vi") return vi_builds_comparison_compareagainst1(inputs)
	if (locale === "tr") return tr_builds_comparison_compareagainst1(inputs)
	if (locale === "cs") return cs_builds_comparison_compareagainst1(inputs)
	if (locale === "bg") return bg_builds_comparison_compareagainst1(inputs)
	if (locale === "ru") return ru_builds_comparison_compareagainst1(inputs)
	if (locale === "uk") return uk_builds_comparison_compareagainst1(inputs)
	if (locale === "ar") return ar_builds_comparison_compareagainst1(inputs)
	if (locale === "hi") return hi_builds_comparison_compareagainst1(inputs)
	if (locale === "th") return th_builds_comparison_compareagainst1(inputs)
	if (locale === "ja") return ja_builds_comparison_compareagainst1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_compareagainst1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_compareagainst1(inputs)
	return ko_builds_comparison_compareagainst1(inputs)
});
export { builds_comparison_compareagainst1 as "builds.comparison.compareAgainst" }